import React from 'react';

import Drawer from '@mui/material/Drawer';
import {styled} from '@mui/material/styles';

export const PANEL_WIDTH = 400;

const Panel = styled(props => (
  <Drawer variant="persistent" anchor="left" {...props} />
))(({theme}) => ({
  width: PANEL_WIDTH,
  flexShrink: 0,
  '& .MuiDrawer-paper': {
    width: PANEL_WIDTH,
    overflow: 'hidden',
    position: 'absolute',
    top: 0,
    bottom: 0,
    backgroundColor: theme.palette.grey[100],
  },
}));

export default Panel;
